"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PaginationControls;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PaginationControls(_ref) {
  var {
    totalPages,
    currentPage,
    setCurrentPage
  } = _ref;
  if (!totalPages) return false;else {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Pagination, {
      className: "pagination",
      itemsPerPage: 10,
      numberOfItems: totalPages * 10,
      currentPage: currentPage,
      onChange: page => {
        setCurrentPage(page);
        window.scrollTo(0, 0);
      }
    });
  }
}